import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSPicItemService from '@/services/Operacoes/SLSPicItem.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function usePicItemList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSPicItemService = new SLSPicItemService();
  const refPicItemListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'DadosItem.item_id', label: 'Item', sortable: true },
    { key: 'DadosItem.item_descricao', label: 'Descrição', sortable: true },
    { key: 'picitemquantidade', label: 'Quantidade', sortable: true },
    { key: 'picitemvalorpic', label: 'Valor R$', sortable: true },
    { key: 'picitemporcentagem', label: 'Desconto %', sortable: true },
    // {key: 'picitemsituacao', label: 'Situação', sortable: true},
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalPicItem = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('picitemsequencia');
  const isSortDirDesc = ref(false);
  const statusFilter = ref(null);
  const overlay = ref(true);
  const idpic = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refPicItemListTable.value ? refPicItemListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPicItem.value,
    };
  });

  const refetchData = () => {
    refPicItemListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchPicItem = (ctx, callback) => {
    sLSPicItemService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      idpic: idpic.value,
      fullObject: true,
    }).then((response) => {
      const { data } = response;
      overlay.value = false;
      // console.log(data);
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalPicItem.value = response.total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    body.picid = idpic.value;
    body.picitemquantidadesaldo = body.picitemquantidade;
    await sLSPicItemService.store(body);
    refetchData();
  };
  const Updated = async (body) => {
    await sLSPicItemService.update(body.itemid, body);
    refetchData();
  };

  const removerData = async (body) => {
    await sLSPicItemService.destroy(body);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem ';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchPicItem,
    tableColumns,
    perPage,
    currentPage,
    totalPicItem,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refPicItemListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,
    idpic,
    // Extra Filters
    statusFilter,
    removerData,
  };
}
